import { IMenus015, useChargeMenuItems } from '@/components/hooks/customs/charge/chargeStation/useChargeMenuItems';
import React, { useEffect } from 'react';
import * as S from '../styles/My015Charge.styles';
/**
 * @title 015 구독 결제 결제 종류 컴포넌트
 *
 * @author 정휘학
 * @since 2024.05.17
 * */

interface IMy015ChargeTop {
  // 결제 수단 변경 Hook
  handlerPayMethodTypes(payMethodTypeCode: string | undefined): void;
  // 결제 수단 코드
  payMethodTypeCodeState: IMenus015['payMethodTypeCode'];
}

const My015ChargeTop = (props: IMy015ChargeTop) => {
  // 캐시 결제 선택하는 useEffect, 디폴트로 돌리려면 상위 Menus015값 주석 해제하고 해당 useEffect 삭제하면 됩니다.
  useEffect(() => {
    props.handlerPayMethodTypes('1');
  }, []);

  const itemHooks = useChargeMenuItems();

  return (
    <S.Payment className="payment">
      {itemHooks.Menus015.map((item) => (
        <button
          key={item.payMethodTypeCode}
          className={props.payMethodTypeCodeState === item.payMethodTypeCode ? 'active' : ''}
          onClick={() => props.handlerPayMethodTypes(item.payMethodTypeCode)}
        >
          {item.title}
        </button>
      ))}
    </S.Payment>
  );
};

export default My015ChargeTop;
